import { FunctionComponent } from 'react';
import { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { TagEditorContext } from 'app/pages/TagEditor/TagEditor';
import { withStyles } from '@material-ui/core/styles';

enum UIComponentKey {
    value = 'value',
}

enum PropertyKey {
    name = 'renderOrder',
}

const CssTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            background: '#fff',
        },
    },
})(TextField);

const RenderOrderBox: FunctionComponent = () => {
    const { markerUpdater, currentMarker: propertyData } = useContext(TagEditorContext);
    const handleChange = (propertykey: PropertyKey, key: UIComponentKey) => {
        return function (event, newValue?) {
            markerUpdater.call({ ...propertyData, [propertykey]: newValue || event.target[key] });
        };
    };

    return (
        <div className="TitlePropertyBox">
            <div className="BoxTitle">Render-Order</div>
            <CssTextField
                id="render-oreder"
                placeholder="0"
                onChange={handleChange(PropertyKey.name, UIComponentKey.value)}
                variant="outlined"
                size="small"
                type="number"
                value={propertyData?.renderOrder ?? 0}
                inputProps={{ min: 0 }}
            />
        </div>
    );
};

export default RenderOrderBox;
